import styled from 'styled-components';
import { FlexContainer, Text } from '@taxdown/piccolo-web';
import ThreeColLayout_ from 'Components/Layouts/ThreeColLayout';
import { DESKTOP_EXTRA_SMALL_WIDTH, MOBILE_WIDTH } from 'Styles/variables/sizes';

export const ThreeColLayout = styled(ThreeColLayout_)`
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    grid-template-columns: 1fr;
    > div:first-child {
      order: 2;
    }
  }
`;
export const TitleContainer = styled<{ isDesktop: boolean }>(Text)`
  width: 100%;
  height: ${({ theme: { spacing } }) => spacing.spacing_40};
  display: ${({ isDesktop }) => (isDesktop ? 'block' : 'none')};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: ${({ isDesktop }) => (isDesktop ? 'none' : 'block')};
  }
`;

export const Container = styled(FlexContainer)`
  background: ${({ theme: { colors } }) => colors.grad_500};
  border-radius: ${({ theme: { spacing } }) => spacing.spacing_16};
  height: 100%;
  width: 100%;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
    margin-top: ${({ theme: { spacing } }) => spacing.spacing_16};
  }
`;
export const LogoContainer = styled(FlexContainer)`
  width: 100%;
  height: 41px;
  background-color: ${({ theme: { system } }) => system.text.fds_sys_color_text_primary};
  border-top-right-radius: ${({ theme: { spacing } }) => spacing.spacing_16};
  border-top-left-radius: ${({ theme: { spacing } }) => spacing.spacing_16};
  img {
    height: 25px;
  }
  div {
    display: flex;
    align-items: center;
    margin-right: 0px;
    height: 25px;
    div {
      svg {
        height: 25px;
        width: 50px;
      }
    }
    svg {
      width: 100px;
    }
  }
`;

export const ContentInfo = styled(FlexContainer)`
  padding: ${({ theme: { spacing } }) => spacing.spacing_16};
  margin-top: ${({ theme: { spacing } }) => spacing.spacing_16};
  max-width: 400px;
`;

export const BulletIcon = styled(Text)`
  padding: ${({ theme: { reference } }) => `${reference.dimension_08} ${reference.dimension_12}`};
  border-radius: ${({ theme }) => theme.sizing.fds_borderradius_round};
  height: fit-content;
  background: ${({ theme: { reference } }) => reference.extended.grass_500};
  color: ${({ theme: { colors } }) => colors.white};
`;
